<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Journal Reclass - Budget Controll 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print JV</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuDimShow=true"><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Date Reclass</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-row>
              <b-col lg="5">
                  <b-input-group >
                    <b-input-group-prepend><label>Journal Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="JV. Number"></b-form-input>
                  </b-input-group>
                </b-col>
              <b-col lg="7">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-2">Group &nbsp;</span></b-input-group-prepend>
                    <b-form-select v-model="tblData.kodejurnal" :plain="true" :options="jurnalGroup"></b-form-select>
                  </b-input-group>
              </b-col>
            </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>GL Account</label></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                <b-form-input v-model="tblData.namaacc" placeholder="Account Name" class="ml-1" style="width:30% !important"></b-form-input>                
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Reference</label></b-input-group-prepend>
              <b-form-input v-model="tblData.reff" placeholder="Reference/Remark"></b-form-input>
                <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        v-model="items" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
       @row-clicked="rowClicked"
      >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(kodeacc)="data"> 
          <span v-if="(data.item.judul=='Y') || (!data.item.namaacc)" style="color:red;"> {{data.item.kodeacc}} | {{data.item.namaacc}} </span>
          <span v-else> {{data.item.kodeacc}} | {{data.item.namaacc}} </span>
        </template>
        <template v-slot:cell(umasuk)="data">
          {{data.item.umasuk|numFormat}}
        </template>
        <template v-slot:cell(ukeluar)="data">
          {{data.item.ukeluar|numFormat}}
        </template>
        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
        <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
    </b-modal>        

  </div>
</template>

<style lang="scss">
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import buku from "../../apis/bukureklasbc";
import lkuDim from "../lookup/lkuDim";
toastr.init();
export default {
  data() {
    return {
      lkuDimShow:false,
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,
        sortBy: 'nomor',
        sortDesc: false,
        DimCol:'Dim1', kodejurnal:''
      },
      jurnalGroup:[{ value: '', text: '-- All Source -' }, 
              { value: 'APINV', text: 'AP Invoice' },
              { value: 'ARINV', text: 'AR Invoice' },
              { value: 'ADVSTTL', text: 'Advance Settlement' },
              { value: 'EXPN', text: 'Expense Reimbursment' },
              { value: 'FIXEDASSET', text: 'Fixed Asset Depreciation' },
              { value: 'BANKOUT', text: 'Bank/Cash Payment' },
              { value: 'BANKIN', text: 'Bank/Cash Receipt' },
          ]      
    };
  },
  components: {Loading, lkuDim},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    tblFields(){
      const fields=[
          {
            key: "nomor",
            label: "JV Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "JV Date",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "Account",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "reff",
            label: "Reference",
          },
          {
            key: "umasuk",
            label: "Debit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ukeluar",
            label: "Credit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          }
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: dims[i].value,
            thStyle: "width:150px",
            label: dims[i].text,
            sortable: true
          },)
        }

      return fields;
    }
  },
watch:{
      dimCol: function(newval) {
          this.tblData.DimVal="";
          this.tblData.DimValInfo="";
          this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
      },
  },
  methods: {
    onSelectedDim: function(_selected){
        this.tblData.DimVal=_selected.nama;
        this.tblData.DimValCode=_selected.kode;
        this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
        this.lkuDimShow=false;
    },    
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.bukujvlist) {
            this.tblData[key] = filter.bukujvlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.bukujvlist.tgl1 || '';
          this.tblData.tgl2=filter.bukujvlist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.bukujvlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await buku.list(this.tblData);      
      this.isLoading=false;
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.kodejurnal=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.DimValCode=  '';
        // this.refresh();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
      let filtered = false;
      const bukujvlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              bukujvlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          bukujvlist.page=this.tblData.page;
          bukujvlist.limit=this.tblData.limit;
          bukujvlist.sortBy=this.tblData.sortBy;
          bukujvlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.bukujvlist=bukujvlist;
          this.$store.commit("filter", filter);
      }
    },    

    add: function(data) {
        this.saveFilter();
          router.push({name :'budget.glbookreklassfrm'});
    },
    edit: function() {
        if (this.model) {
            this.saveFilter();
            router.push({name :'budget.glbookreklassfrm', params: { nomor: this.model.nomor, tanggal:this.model.tanggal}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
       this.isLoading=true;
        await buku.remove(this.model);
          this.refresh();
        // const objdeleted = this.items.filter(r => ((r.nomor==this.model.nomor) && (r.tanggal==this.model.tanggal)));
        // if (objdeleted) {
        //     objdeleted.forEach((d) => {
        //           const index= this.items.findIndex(r => (r.bukukey==d.bukukey));
        //           this.items.splice(index, 1);
        //     });
        // }
        this.isLoading=false;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    printjv: async function()
    {
       if (this.model) {
          try {              this.showReport=true;

              this.reportUrl= await buku.printjv(this.model);

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
          toastr.warn('Please select one Data taht want to print ');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await buku.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
      router.push("home");
    },    

  }
};
</script>
